const runtimeConfig = window['runtime-config'];

export default runtimeConfig;
